import { Observable } from 'rxjs'
import { distinctUntilChanged, filter, tap } from 'rxjs/operators'
import { AppState } from 'src/app/core/core.state'

import { Component, OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { bookingSelectors } from '../booking.selectors'
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy'
export let hardRefreshInComponent: boolean = false
@UntilDestroy()
@Component({
  selector: 'booking-show',
  templateUrl: './show.component.html',
  styleUrls: ['./show.component.scss']
})
export class BookingShowComponent implements OnInit {
  public bookingId$: Observable<number>

  constructor(private store: Store<AppState>) {}

  ngOnInit() {
    this.bookingId$ = this.store
      .select(bookingSelectors.selectIdRouteParam)
      .pipe(
        untilDestroyed(this),
        filter((bookingIdRouteParam) => Boolean(bookingIdRouteParam)),
        distinctUntilChanged()
      )
  }
}
